module.exports = __webpack_public_path__ + "dummyImagebig.png?7cd4284951406ff4f2cc3a8885582ea9";